/* global G */

/**
 * Initializes the ACLs by dispatching `G.ACL, G.CACHE` event
 *
 * @param {Gaia.Web.Application|Gaia.AppModule.Spec} obj the platform Application
 * @returns {function(*): *}
 */
const init = obj => (args) => {
  obj[G.ADAPTER][G.EVENTS].dispatch(obj[G.ADAPTER][G.EVENTS].type(G.ACL, G.CACHE))

  return args
}

export default init
